<template>
  <div class="navbar-wrapper" id="tsection">
    <transition name="fade">
    <div class="active-nav" v-if="toggle">
      <div class="link shorthand">
        <div class="small-div" v-if="false">
          <a href="http://shop.lasting-impressions.com.my" class="div-link">
            Shop
          </a>
        </div>
        <div class="small-div">
          <a href="/?anchor=gallery-container" class="div-link">
            Gallery
          </a>
        </div>
        <div class="small-div">
          <a href="/about" class="div-link">
            About
          </a>
        </div>
        <div class="small-div">
          <a href="/locate" class="div-link">
            Locate
          </a>
        </div>
        <div class="small-div">
          <div>
            <a class="elink" href="mailto:sales@lasting-impressions.com.my;jonathan@lasting-impressions.com.my">sales@lasting-impressions.com.my</a>
          </div>
        </div>
        <div class="small-div">
          <div class="eicon">
            <a class="top-icon facebook" href="https://www.facebook.com/lastingimpressionskl" target="_blank">
              <i class="fa fa-facebook" aria-hidden="true"></i>
            </a>
          </div>
        </div>
        <div class="small-div">
          <div class="eicon">
            <a class="top-icon instagram" href="https://www.instagram.com/lastingimpressionskl" target="_blank">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <div class="full-layer">
      <navbar-full :toggle="toggle" @onToggle="toggle = $event"></navbar-full>
    </div>
  </div>
</template>

<script>
import NavbarFull from './NavBarFull.vue'

export default {
  name: 'topsection',
  components: {
    'NavbarFull': NavbarFull
  },
  data () {
    return {
      toggle: false
    }
  },
  watch: {
    toggle: function (val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  methods: {
    onlink: function (el) {
      this.toggle = !this.toggle
      var root = document.documentElement
      root.className = ''

      this.$scrollTo(el)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/app_setting.scss";

.topsection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topsection {
  min-height: 250px;
  width: 100%;
  height: auto;
  position: relative;
  background: transparent;
  margin-top: 50px;

  @media screen and (min-width: $desktop) {
    margin-top: 0;
  }
  & .ccontainer {
    max-width: 1152px !important;
    z-index: 1;
  }
}

$color-yellow: #FEC624;
$widescreen: 1200px;

#tsection {
  // min-height: 100vh;

  & .active-nav {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.9);
    z-index: 10;
    line-height: 1;
    vertical-align: middle;
    justify-content: center;
    align-items: center;
    display: flex;

    & .link a {
      color: $color-black;
      font-size: 1.2em;
      display: block;
      margin-bottom: 0rem;

      @media screen and (min-width: $tablet) {
        margin-bottom: 1rem;
      }

      @media screen and (min-width: $desktop) {
        margin-bottom: 1rem;
      }
      // potrait
      @media (max-width: 420px) and (min-height: 480px) {
        margin-bottom: 1rem;

        // extra mini
        @media (max-width: 320px) {
          margin-bottom: 0rem;
        }
      }
      // landscape mobile
      @media (min-width: 480px) and (max-height: 420px) {
        margin-bottom: 1rem;
      }

      &:before {
        background-color: $color-black;
      }
      &:hover {
        color: $color-gold;
      }

      // icon
      &.top-icon {
        padding: 8px;
        &.facebook {
          padding: 7px 13px 4px 12px;
        }
        &.instagram {
          padding: 7px 8px 6px 9px;
        }
        padding: 5px 10px 7px 11px;
        border: 2px solid #4c5454;
        border-radius: 30px;
        font-size: 1.2em;

        &:hover {
          background-color: #4c5454;
          color: white;
        }
      }
    }
    & .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      height: 100%;

      &.shorthand {
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-flex-direction: row;
        flex-direction: row;
        height: 50%;

        & .small-div {
          width: 100%;
          text-align: center;

          // potrait
          @media (max-width: 420px) and (min-height: 480px) {
            width: 100%;
          }
          // landscape mobile
          @media (min-width: 480px) and (max-height: 420px) {
            width: 50%;
          }

          & div,
          & .div-link {
            display: inline-block;
            text-align: center;
            padding: 0.5rem;
          }
          &:first-child {
            // @media screen and (min-height: 601px) {
            margin-top: 2rem;

            @media screen and (min-width: $tablet) {
              margin-top: 2rem;
            }
            // potrait
            @media (max-width: 420px) and (min-height: 480px) {
              margin-top: 2rem;
            }
            // landscape mobile
            @media (min-width: 480px) and (max-height: 420px) {
              margin-top: 0rem;
            }
          }
          // &:nth-child(5) {
          //   margin-top: 2em;
          //   @media (min-width: 480px) and (max-height: 420px) {
          //     margin-top: 0rem;
          //   }
          // }
        }
      }
    }
    & .link .elink {
      &:before {
        background-color: $color-red;
      }
      &:hover {
        color: $color-gold;
      }
    }
    & .link .eicon {
      // custom for iphone 4 and 5
      & a {
        display: inline-block;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        &:before {
          height: 0;
        }
      }
      & i {
        font-size: 2rem;
        // width: 50px;
        // height: 50px;
        vertical-align: middle;
      }
    }
  }

  & .logo {
    padding: 0 30px;
    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }
  & .sub {
    padding: 30px 30px;
    @media screen and (min-width: $tablet) {
      padding-top: 50px;
      padding-left: 60px;
      padding-right: 60px;
    }
    @media screen and (min-width: $desktop) {
      padding-top: 50px;
      padding-left: 30px;
      padding-right: 30px;
    }
    @media screen and (min-width: $widescreen) {
      padding-top: 70px;
    }
  }
}

.full-layer {
  // min-height: 100vh;
  /*height: 100px;*/
  display: flex;
  flex-direction: column;

  // html.modal-open & {
  //   // this to remove scrollability
  //   pointer-events: none;
  // }
}
@media screen and (min-width: 1008px) {
  .topsection {
    min-height: calc(100vh - 135px);
  }
}
</style>



// WEBPACK FOOTER //
// NavBarOverlay.vue?2b9cd3b7